import PropTypes from 'prop-types';
import { memo } from 'react';

import { TrlFieldContainer } from '../TrlFieldContainer';
import {
  FieldValueStyled,
  InfoFieldContainerStyled,
} from './TrlInfoField.styles';

export const TrlInfoField = memo(({ value, label }) => {
  return (
    <InfoFieldContainerStyled>
      <TrlFieldContainer label={label}>
        <FieldValueStyled>{value || '-'}</FieldValueStyled>
      </TrlFieldContainer>
    </InfoFieldContainerStyled>
  );
});

TrlInfoField.displayName = 'TrlInfoField';

TrlInfoField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
};
